import type { i18n as I18n } from "i18next";
import en from "@/locales/en/duels/connect-four.json";
import fr from "@/locales/fr/duels/connect-four.json";

export const CONNECT_FOUR_NS = "duels/connect-four";

/** Adds this duel's translations to an initialised i18next instance (idempotent). */
export function registerConnectFourTranslations(i18n: I18n): void {
  if (!i18n.hasResourceBundle("en", CONNECT_FOUR_NS))
    i18n.addResourceBundle("en", CONNECT_FOUR_NS, en, true, true);
  if (!i18n.hasResourceBundle("fr", CONNECT_FOUR_NS))
    i18n.addResourceBundle("fr", CONNECT_FOUR_NS, fr, true, true);
}
